const AbmInitialState = {
   abm:{
    data: false, 
    loading: false, 
    error: false, 
    selectedItem: false,
   }
}

export default AbmInitialState; 